const REVEAL_ATTR = 'data-scroll-reveal';
const VISIBLE_CLASS = 'is-visible';

function initScrollReveal() {
  const elements = document.querySelectorAll(`[${REVEAL_ATTR}]:not(.${VISIBLE_CLASS})`);
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (const element of elements) element.classList.add(VISIBLE_CLASS);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(VISIBLE_CLASS);
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  for (const element of elements) observer.observe(element);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal);
} else {
  initScrollReveal();
}
